import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import { getMoreByLinkType } from '../../helpers';

import s from './MoreByAuthor.scss';

export interface Props {
  contentType: string;
  deviation: PapiDeviation;
  className?: string;
}

const MoreByAuthor: React.FC<React.PropsWithChildren<Props>> = ({
  contentType,
  deviation,
  className,
}) => {
  const { deviationId, author } = deviation;

  if (!author) {
    return null;
  }

  return (
    <UserLink
      className={classnames(s['root'], className)}
      user={author}
      linkTo={getMoreByLinkType(contentType) as any}
      anchor
      deviationIdSeed={deviationId}
    >
      {/* prettier-ignore */}
      <Trans i18nKey={`sidebar.blockTitle.${contentType}`}>
        More things
        by <BasicUserName user={author} />
      </Trans>
    </UserLink>
  );
};
MoreByAuthor.displayName = 'MoreByAuthor';

export default MoreByAuthor;
